// Settings — auth, billing, team, integrations.

import { PageHeader, StubBanner } from '../components/Page';
import { Card, CardLabel, CardTitle } from '../components/Card';
import { T } from '../theme';

export default function Settings() {
  return (
    <>
      <PageHeader
        title="Settings"
        subtitle="Auth, team, billing, integrations. The studio's plumbing."
      />

      <StubBanner section="settings" />

      <div style={setStyles.grid}>
        <Card>
          <CardLabel>i · Account</CardLabel>
          <CardTitle>Sign-in + sessions</CardTitle>
          <p style={setStyles.muted}>
            Authenticated via Google OAuth on admin.imorbis.com. Active sessions,
            recent sign-ins, device list. Sign out everywhere.
          </p>
        </Card>

        <Card>
          <CardLabel>ii · Team</CardLabel>
          <CardTitle>Operators + access</CardTitle>
          <p style={setStyles.muted}>
            Who has access to this studio. Role assignment (operator, brand, creator,
            admin). Invite by email; resolved through Contacts API.
          </p>
        </Card>

        <Card>
          <CardLabel>iii · Billing</CardLabel>
          <CardTitle>Stripe integration</CardTitle>
          <p style={setStyles.muted}>
            Brand deposits, creator payouts, platform fee configuration. Invoice
            history, payout schedule, currency settings.
          </p>
        </Card>

        <Card>
          <CardLabel>iv · Integrations</CardLabel>
          <CardTitle>Connected services</CardTitle>
          <p style={setStyles.muted}>
            Discord (live), Google Calendar (live), Stripe (live), Spotify (Phase 5),
            TikTok / Instagram / YouTube (Phase 5). Per-integration status + reconnect.
          </p>
        </Card>

        <Card>
          <CardLabel>v · Branding</CardLabel>
          <CardTitle>Studio identity</CardTitle>
          <p style={setStyles.muted}>
            Logo, accent colors, report templates, Discord bot copy. Per-tenant
            customization for white-label deployments.
          </p>
        </Card>

        <Card>
          <CardLabel>vi · Audit</CardLabel>
          <CardTitle>System events</CardTitle>
          <p style={setStyles.muted}>
            Every write the studio worker performed. Filterable by actor, resource,
            time range. The trust layer's evidence surface.
          </p>
        </Card>
      </div>
    </>
  );
}

const setStyles: Record<string, React.CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 20,
  },
  muted: {
    fontSize: 14,
    color: T.inkSoft,
    lineHeight: 1.65,
  },
};
